import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M10.155 0 8.198.415l.62 2.935 1.957-.413-.62-2.935ZM8.253 10.095a3 3 0 0 1 5.329-1.891l1.122-1.727a5 5 0 1 0-5.357 8.242l1.123-1.727a3.001 3.001 0 0 1-2.217-2.897ZM5.157 23 13.5 10.165l3.252 5.003L18 12.984 23.723 23H5.157ZM2.317 5.371 3.41 3.696l2.514 1.637L4.83 7.009 2.317 5.37Zm15.221-3.213-1.675-1.091-1.638 2.513 1.676 1.092 1.637-2.514ZM6.584 15.311l1.675 1.092-1.637 2.514-1.676-1.092 1.638-2.514Zm-5.333-4.232.413 1.956 2.936-.62-.413-1.956-2.936.62Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconFinanceFarEast24 = createIcon(IconComponent);